"use client"

import { useAccount } from "wagmi"
import ConnectWalletButton from "@/app/components/ConnectWalletButton"

import {
  NFTMintBtnProps,
  isCompletedCollectible,
  isDraftCollectible,
} from "../types"
import {
  ExistingNFTMintBtnSimulate,
  NewNFTMintBtnSimulate,
} from "./SimulateTxn"
import { getBlogTheme } from "@/lib/utils/themes"
import { cn } from "@/lib/utils"

export default function ConnectWalletOrMint(props: NFTMintBtnProps) {
  const address = useAccount().address

  const themeClassName = getBlogTheme(props.blog.theme)

  if (!address) {
    return <ConnectWalletButton className={cn("w-full", themeClassName)} />
  }

  if (isCompletedCollectible(props.collectible)) {
    return (
      <ExistingNFTMintBtnSimulate
        collectible={props.collectible}
        className={themeClassName}
      />
    )
  }

  if (isDraftCollectible(props)) {
    return (
      <NewNFTMintBtnSimulate
        draftCollectible={props.collectible}
        blog={props.blog}
        post={props.post}
        className={themeClassName}
      />
    )
  }
}
